import { Download, FileText } from "lucide-react";
import { SectionHeading } from "./ProductSelector";
import { PRODUCTS } from "../../data/products";

export default function Downloads() {
  return (
    <section id="pobierz" data-testid="downloads-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="06 · Pliki do pobrania"
          title="Karty techniczne."
          subtitle="Pełna dokumentacja techniczna każdego z wariantów wełny mineralnej szklanej w formacie PDF."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-0 border-2 border-black">
          {PRODUCTS.map((p, idx) => (
            <a
              key={p.id}
              href={p.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`download-${p.id}`}
              className={`group p-7 lg:p-8 bg-white hover:bg-black hover:text-white transition relative ${
                idx !== PRODUCTS.length - 1 ? "md:border-r-2 border-black" : ""
              } ${idx !== PRODUCTS.length - 1 ? "border-b-2 md:border-b-0 border-black" : ""}`}
            >
              <div className="flex items-center justify-between mb-5">
                <FileText
                  className="h-10 w-10 text-red-600 group-hover:text-red-500 transition"
                  strokeWidth={1.6}
                />
                <Download className="h-5 w-5 text-zinc-400 group-hover:text-white transition" />
              </div>
              <div className="font-tech text-[10px] uppercase tracking-[0.3em] text-zinc-400 group-hover:text-zinc-300 mb-2">
                Karta techniczna
              </div>
              <h3 className="font-display text-2xl uppercase tracking-tight leading-snug mb-3">
                {p.name}
              </h3>
              <p className="text-sm text-zinc-600 group-hover:text-zinc-300 leading-relaxed mb-4">
                Pełne parametry techniczne, klasa A1, dostępne grubości,
                deklaracja właściwości użytkowych.
              </p>
              <span className="font-tech text-[11px] uppercase tracking-widest text-zinc-400 group-hover:text-zinc-300">
                PDF · pobierz
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
